module.exports = __webpack_public_path__ + "img/info.88d0e93f.svg";